import * as React from "react";
import { ModalComponent } from "shared/components/modal/modal";
import "./menu-description-modal.less";
import { shallowEqual, useSelector } from "react-redux";
import { closeMenuDescriptionModal, selectMenuDescriptionModal } from "states/global-value/global-value.slice";
import { isDesktop } from "react-device-detect";
import { useAppDispatch } from "app.hook";
export function MenuDescriptionModal() {
  const dispatch = useAppDispatch();
  let menuDescriptionModal = useSelector(selectMenuDescriptionModal,shallowEqual);
  return <>
    <ModalComponent
      portalClassName={`ModalMenuDescription`}
      width={`${!isDesktop ? `100%`:`800px`}`}
      height={`auto`}
      className="w-full bg-white rounded-2xl"
      isCustomizeFooter={true}
      isModal={true}
      onCloseModal={()=>{
        dispatch(closeMenuDescriptionModal());
      }}
      isOpenModal={menuDescriptionModal?.open}
      title={`Description`}
    >
      <div className="p-3">
        <div dangerouslySetInnerHTML={{__html:menuDescriptionModal?.description}} />
      </div>
    </ModalComponent>
  </>;
}
